<template>
  <section id="landing-opinions">
    <header class="landing-default">
      <h3>Poznaj opinie użytkowników</h3>
      <h5>Zyskaliśmy uznanie wielu przedsiębiorców. Dołącz do grona zadowolonych Klientów!</h5>
    </header>
    <hr>
    <div class="opinion">
      <blockquote>"{{ opinions[activeOpinion].text}}"</blockquote>
      <h6>{{ opinions[activeOpinion].author }}</h6>
    </div>
    <div class="pagination">
      <div :class="{ active: activeOpinion == index }" v-for="(value, index) in opinions" :key="value.index" @click="changeOpinion(index)"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LandingOpinions',
  data(){
    return{
      inteval: 0,
      activeOpinion: 0,
      opinions: [
        {
          index: 1,
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec lacinia erat, vulputate commodo libero. In vestibulum mauris mauris, aliquam sodales lectus bibendum eu. Curabitur et lacinia risus. Cras condimentum leo urna, vitae pellentesque quam consequat quis. Vestibulum ante ipsum primis in faucibus.',
          author: 'Jan Kowalski1'
        },
        {
          index: 2,
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec lacinia erat, vulputate commodo libero. In vestibulum mauris mauris, aliquam sodales lectus bibendum eu. Curabitur et lacinia risus. Cras condimentum leo urna, vitae pellentesque quam consequat quis. Vestibulum ante ipsum primis in faucibus.',
          author: 'Jan Kowalski2'
        },
        {
          index: 3,
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec lacinia erat, vulputate commodo libero. In vestibulum mauris mauris, aliquam sodales lectus bibendum eu. Curabitur et lacinia risus. Cras condimentum leo urna, vitae pellentesque quam consequat quis. Vestibulum ante ipsum primis in faucibus.',
          author: 'Jan Kowalski3'
        },
        {
          index: 4,
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec lacinia erat, vulputate commodo libero. In vestibulum mauris mauris, aliquam sodales lectus bibendum eu. Curabitur et lacinia risus. Cras condimentum leo urna, vitae pellentesque quam consequat quis. Vestibulum ante ipsum primis in faucibus.',
          author: 'Jan Kowalski4'
        },
      ]
    }
  },
  created(){
    this.setMyInverval();
  },
  methods:{
    changeOpinion(index){
      this.activeOpinion = index;
      clearInterval(this.interval);
      this.setMyInverval();
    },
    changeOpinionTimely(){
      if(this.activeOpinion == (this.opinions.length - 1)){
        this.activeOpinion = 0;
      }else{
        this.activeOpinion += 1;
      }
    },
    setMyInverval(){
      let self = this;
      this.interval = setInterval(self.changeOpinionTimely, 15000);
    },
  }
}
</script>

<style lang="scss">
  section#landing-opinions { margin-bottom: 100px; } 
  section#landing-opinions hr { width: 67px; margin: 50px auto 25px auto; border: 0; border-bottom: 3px solid $orangeLight; }
  section#landing-opinions div.opinion blockquote { width: 800px; margin: 0 auto; font-style: italic; font-size: 17px; font-weight: 300; color: $fontBlack; }
  section#landing-opinions div.opinion h6 { width: 800px; margin: 15px auto; padding: 0; font-weight: 500; font-size: 17px; text-align: right; color: $fontBlack; }
  section#landing-opinions div.pagination { display: flex; justify-content: center; margin-top: 15px; }
  section#landing-opinions div.pagination div { width: 13px; height: 13px; margin: 0 3px; border-radius: 3px; 
    background: rgba(0, 0, 0, 0.1); cursor: pointer; }
  section#landing-opinions div.pagination div.active { background: $orangeLight; }

  @media (max-width: 800px) {
    section#landing-opinions div.opinion blockquote { width: 100%; padding: 0 30px; text-align: center; }
    section#landing-opinions div.opinion h6 { width: 100%; padding: 0 15px; }
  }
</style>
